import { useNavigate } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { Button } from '../Button';
import { PageNotFoundLayout } from '../../layouts/PageNotFoundLayout';

export function NoCompletedSurveysFound() {
    const navigate = useNavigate();
    return (
        <PageNotFoundLayout
            hiddenFooter
            hiddenHeader
            hiddenStatus
            title={
                <FormattedMessage
                    defaultMessage="There are no survey results yet"
                    description="Error page title"
                />
            }
            description={
                <FormattedMessage
                    defaultMessage="Go to projects page to check on your surveys."
                    description="Error page description"
                />
            }
            actionButtons=<Button
                onClick={() => {
                    navigate('../projects');
                }}
            >
                <FormattedMessage
                    defaultMessage="Go to projects page"
                    description="Button to go to projects"
                />
            </Button>
        />
    );
}
